{
  "pages": {
    "listTitle": "Quản lý phòng khám",
    "addTitle": "Thêm phòng khám mới",
    "editTitle": "Sửa phòng khám",
    "detailsTitle": "Chi tiết phòng khám",
    "permissionDenied": "Bạn không có quyền xem danh sách phòng khám.",
    "addPermissionDenied": "Bạn không có quyền thêm phòng khám.",
    "editPermissionDenied": "Bạn không có quyền chỉnh sửa phòng khám.",
    "requiredFieldsNote": "Các trường có dấu * là bắt buộc",
    "loadingClinic": "Đang tải phòng khám...",
    "notFound": "Không tìm thấy phòng khám",
    "notFoundMessage": "Không tìm thấy phòng khám."
  },
  "fields": {
    "clinic": "Phòng khám",
    "name": "Tên phòng khám",
    "shortName": "Tên viết tắt",
    "shortNameHelper": "Dùng trong giao diện nội bộ (tối đa 40 ký tự). Để trống thì hiển thị tên đầy đủ.",
    "branchCode": "Mã phòng khám",
    "branchCodeHelper": "Mã duy nhất cho chi nhánh này (bắt buộc)",
    "address": "Địa chỉ",
    "streetAddress": "Số nhà, tên đường",
    "ward": "Phường/Xã",
    "province": "Tỉnh/Thành phố",
    "location": "Địa điểm",
    "contact": "Liên hệ",
    "phone": "Số điện thoại",
    "email": "Email",
    "status": "Trạng thái",
    "chairs": "Số ghế",
    "numberOfChairs": "Số ghế",
    "numberOfChairsHelper": "Số ghế đang dùng. Thêm ghế thủ công trong mục Ghế nha.",
    "day": "Thứ",
    "hours": "Giờ",
    "open": "Mở cửa",
    "openTime": "Giờ mở",
    "closeTime": "Giờ đóng",
    "coordinates": "Tọa độ",
    "latitude": "Vĩ độ (Latitude)",
    "longitude": "Kinh độ (Longitude)",
    "googleMapsUrl": "Link Google Maps",
    "googleMapsUrlHelper": "Dán link địa điểm trên Google Maps để điền tọa độ. Không ghi đè địa chỉ.",
    "googleMapsUrlApplied": "Đã lấy tọa độ từ link.",
    "geofenceRadius": "Bán kính vùng chấm công",
    "geofenceRadiusMeters": "Bán kính chấm công (m)",
    "geofenceRadiusHelper": "Mặc định 150m",
    "wifiEnabled": "Chấm công Wi‑Fi",
    "wifiEnabledHelper": "Khớp IP public của mạng phòng khám. Khi cùng bật với GPS thì ưu tiên Wi‑Fi.",
    "gpsEnabled": "Chấm công GPS",
    "gpsEnabledHelper": "Yêu cầu vị trí trong bán kính chi nhánh.",
    "wifiNetworks": "Mạng Wi‑Fi chấm công",
    "wifiNetworksHelper": "Tên chỉ để nhận biết. Hệ thống khớp IP public (tối đa 5).",
    "wifiName": "Tên Wi‑Fi",
    "wifiIp": "Địa chỉ IP",
    "currentIp": "IP hiện tại của bạn: {{ip}}",
    "requireCompleteClocks": "Bắt buộc đủ giờ vào/ra trước khi khoá tháng",
    "requireCompleteClocksHelper": "Không khóa bảng công khi còn bản ghi có mặt thiếu vào hoặc ra.",
    "subtractBreakFromWorkedHours": "Trừ giờ nghỉ giữa ca khỏi giờ tính công",
    "subtractBreakHelper": "Bật: giờ làm = giờ ra − giờ vào, rồi trừ giờ nghỉ đã khai trên loại ca. Tắt: tính trọn từ vào đến ra.",
    "halfDayHoursThreshold": "Ngưỡng nửa công (giờ)",
    "halfDayHoursHelper": "Có mặt dưới số giờ này → 0,5 công. 0 = tắt.",
    "absentHoursThreshold": "Ngưỡng vắng (giờ)",
    "absentHoursHelper": "Có mặt dưới số giờ này → 0 công. 0 = tắt. Phải nhỏ hơn ngưỡng nửa công nếu cả hai bật.",
    "bookingDentistOverlap": "Trùng lịch bác sĩ",
    "bookingChairOverlap": "Trùng lịch ghế",
    "bookingClinicHours": "Ngày & giờ phòng khám",
    "bookingStaffSchedule": "Lịch làm của bác sĩ",
    "bookingRequireChair": "Bắt buộc chọn ghế",
    "bookingSlotStepMinutes": "Bước khung giờ (phút)",
    "bookingBufferBeforeMinutes": "Đệm trước (phút)",
    "bookingBufferBeforeHelper": "0–240 phút. 0 = không đệm.",
    "bookingBufferAfterMinutes": "Đệm sau (phút)",
    "bookingBufferAfterHelper": "0–240 phút. 0 = không đệm.",
    "bookingMinLeadMinutes": "Đặt trước tối thiểu (phút)",
    "bookingMinLeadHelper": "0–10080. 0 = tắt.",
    "bookingMaxAdvanceDays": "Đặt trước tối đa (ngày)",
    "bookingMaxAdvanceHelper": "0–730. 0 = tắt."
  },
  "placeholders": {
    "name": "Nhập tên phòng khám",
    "shortName": "Nhập tên viết tắt",
    "branchCode": "Q1",
    "street": "Số nhà, tên đường",
    "ward": "Chọn phường/xã",
    "province": "Chọn tỉnh/thành phố",
    "phone": "Ví dụ: 0901234567",
    "email": "email@example.com",
    "latitude": "10.782345",
    "longitude": "106.689123",
    "googleMapsUrl": "https://www.google.com/maps/place/...",
    "geofenceRadiusMeters": "150",
    "wifiName": "Wi-Fi lễ tân",
    "wifiIp": "118.70.1.10",
    "halfDayHoursThreshold": "0",
    "absentHoursThreshold": "0",
    "numberOfChairs": "4",
    "bookingBufferMinutes": "0",
    "bookingMinLeadMinutes": "0",
    "bookingMaxAdvanceDays": "0"
  },
  "sections": {
    "contactInformation": "Thông tin liên hệ",
    "general": "Thông tin chung",
    "gpsAttendance": "Cấu hình chấm công",
    "gpsAttendanceHint": "Bật từng phương thức. Cả hai bật thì chấm Wi‑Fi trước, không khớp mới dùng GPS.",
    "payPolicy": "Cấu hình ngày công",
    "payPolicyHint": "Nội quy công của phòng khám. 0 giờ = không cắt công theo số giờ làm.",
    "bookingPolicy": "Chính sách đặt lịch",
    "bookingPolicyHint": "Mặc định theo tổ chức. Chỉ ghi đè khi phòng khám khác quy tắc chung của tổ chức.",
    "operatingHours": "Giờ làm việc",
    "operatingHoursHint": "Mặc định Thứ 2–Thứ 7 mở 07:30–18:00, Chủ nhật đóng. Có thể chỉnh theo từng ngày.",
    "chairs": "Ghế nha",
    "chairsHint": "Thêm từng ghế. Để trống mã thì hệ thống tự tạo từ tên."
  },
  "bookingPolicy": {
    "inherit": "Theo tổ chức",
    "override": "Ghi đè",
    "block": "Chặn",
    "warn": "Cảnh báo",
    "allow": "Cho phép",
    "scheduleBlock": "Chặn (không cho đặt)",
    "scheduleWarn": "Cảnh báo (xác nhận mới đặt)",
    "scheduleAllow": "Cho đặt",
    "if_configured": "Khi đã có ghế",
    "always": "Luôn bắt buộc",
    "never": "Không bắt buộc"
  },
  "payPolicy": {
    "enabled": "Bật",
    "disabled": "Tắt",
    "thresholdOff": "Tắt (0)",
    "hoursValue": "{{hours}} giờ"
  },

  "chairs": {
    "title": "Ghế nha",
    "actions": {
      "add": "Thêm ghế",
      "remove": "Xóa ghế"
    },
    "fields": {
      "name": "Tên ghế",
      "code": "Mã ghế",
      "codeHelper": "Để trống sẽ tự tạo từ tên",
      "sortOrder": "Thứ tự",
      "status": "Trạng thái"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "dialogs": {
      "addTitle": "Thêm ghế nha",
      "editTitle": "Sửa ghế nha"
    },
    "table": {
      "empty": "Chưa có ghế nha"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên ghế"
    },
    "toasts": {
      "loadFailed": "Không tải được danh sách ghế",
      "created": "Đã thêm ghế nha",
      "updated": "Đã cập nhật ghế nha",
      "deactivated": "Đã ngừng dùng ghế nha",
      "saveFailed": "Không lưu được ghế nha",
      "deactivateFailed": "Không ngừng dùng được ghế nha"
    }
  },

  "status": {
    "active": "Đang hoạt động",
    "underMaintenance": "Đang bảo trì",
    "inactive": "Ngừng hoạt động",
    "unknown": "Không xác định"
  },
  "days": {
    "monday": "Thứ Hai",
    "tuesday": "Thứ Ba",
    "wednesday": "Thứ Tư",
    "thursday": "Thứ Năm",
    "friday": "Thứ Sáu",
    "saturday": "Thứ Bảy",
    "sunday": "Chủ Nhật"
  },
  "actions": {
    "addClinic": "Thêm phòng khám",
    "addingClinic": "Đang thêm phòng khám...",
    "updateClinic": "Cập nhật phòng khám",
    "updatingClinic": "Đang cập nhật phòng khám...",
    "view": "Xem",
    "history": "Lịch sử",
    "edit": "Sửa",
    "delete": "Xóa",
    "deleting": "Đang xóa...",
    "clinicActions": "Thao tác phòng khám",
    "dayOpenAria": "{{day}} mở cửa",
    "addWifi": "Thêm Wi‑Fi",
    "addCurrentIp": "Thêm IP hiện tại",
    "removeWifi": "Xóa mạng Wi‑Fi",
    "applyMapsUrl": "Lấy tọa độ"
  },
  "filters": {
    "allStatuses": "Tất cả trạng thái",
    "searchPlaceholder": "Tìm phòng khám..."
  },
  "table": {
    "empty": "Không tìm thấy phòng khám"
  },
  "fallbacks": {
    "addressUnavailable": "Chưa có địa chỉ",
    "phoneUnavailable": "Chưa có số điện thoại",
    "gpsNotConfigured": "Chưa cấu hình tọa độ GPS",
    "wifiNotConfigured": "Chưa cấu hình Wi‑Fi chấm công",
    "closed": "Đóng cửa"
  },
  "history": {
    "title": "Lịch sử",
    "empty": "Chưa có hoạt động nào được ghi nhận."
  },
  "dialogs": {
    "deleteTitle": "Xóa phòng khám",
    "deleteConfirm": "Bạn có chắc muốn xóa phòng khám \"{{name}}\"? Hành động này không thể hoàn tác."
  },
  "toasts": {
    "loadListFailed": "Không tải được danh sách phòng khám. Vui lòng thử lại.",
    "loadFailed": "Không tải được phòng khám",
    "loadDetailsFailed": "Không tải được chi tiết phòng khám. Vui lòng thử lại.",
    "addSuccess": "{{name}} đã được thêm thành công",
    "addFailed": "Thêm phòng khám thất bại",
    "updateSuccess": "{{name}} đã được cập nhật thành công",
    "updateFailed": "Cập nhật phòng khám thất bại",
    "deleteSuccess": "Đã xóa phòng khám thành công",
    "deleteFailed": "Xóa phòng khám thất bại",
    "formHasErrors": "Vui lòng sửa các trường được đánh dấu"
  },
  "validation": {
    "nameRequired": "Vui lòng nhập tên phòng khám",
    "branchCodeRequired": "Vui lòng nhập mã chi nhánh",
    "addressRequired": "Vui lòng nhập địa chỉ",
    "wardRequired": "Vui lòng nhập phường/xã",
    "provinceRequired": "Vui lòng nhập tỉnh/thành phố",
    "phoneRequired": "Vui lòng nhập số điện thoại",
    "chairsRequired": "Thêm ít nhất một ghế có tên",
    "chairNameDuplicate": "Tên ghế không được trùng",
    "chairCodeDuplicate": "Mã ghế không được trùng",
    "latLngBothRequired": "Nhập cả vĩ độ và kinh độ",
    "latitudeRange": "Vĩ độ phải từ -90 đến 90",
    "longitudeRange": "Kinh độ phải từ -180 đến 180",
    "geofenceRadiusRange": "Bán kính phải từ 10 đến 5000 mét",
    "wifiNetworksMax": "Tối đa {{max}} mạng Wi‑Fi",
    "wifiNameRequired": "Nhập tên Wi‑Fi (tối đa 64 ký tự)",
    "wifiIpPublic": "IP phải là IPv4 public, không dùng 192.168… / 10…",
    "wifiIpDuplicate": "Mỗi IP chỉ được khai báo một lần",
    "wifiNetworksRequired": "Bật chấm Wi‑Fi thì cần ít nhất một mạng",
    "gpsCoordinatesRequired": "Bật chấm GPS thì cần nhập tọa độ",
    "googleMapsUrlInvalid": "Không đọc được tọa độ từ link. Mở Google Maps, sao chép liên kết địa điểm rồi dán lại.",
    "googleMapsUrlShort": "Link rút gọn không chứa tọa độ. Mở link trên trình duyệt, sao chép liên kết đầy đủ rồi dán lại.",
    "payHoursRange": "Số giờ phải từ 0 đến 24",
    "absentBelowHalfDay": "Ngưỡng vắng phải nhỏ hơn ngưỡng nửa công",
    "bookingNumericRange": "Giá trị phải từ 0 đến {{max}}",
    "dayTimesRequired": "{{day}}: cần nhập giờ mở và giờ đóng"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} / {{count}}",
    "moreThan": "hơn {{to}}"
  }
}
